module.exports = {
  provides: 'offset',
  shouldTrack: true,
  isLazy: true,

  getter: [
    function() {
      // TODO(tyler): use DateEnv (once it supports new Date)
      return (new Date()).getTimezoneOffset();
    },
  ],
};
